import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=7ea6771e&scoped=true&"
import script from "./RoleAdd.vue?vue&type=script&lang=js&"
export * from "./RoleAdd.vue?vue&type=script&lang=js&"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=7ea6771e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea6771e",
  null
  
)

export default component.exports